import React from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import { useTranslation } from 'react-i18next';
import Checkbox from 'components/common/radio-button';
import { Message } from 'components/alert/Message';
import { get } from 'lodash';
import FormikErrorMessage from 'components/formik-error-message';
import Heading from 'components/Heading/Heading';
import { P } from 'components/reusable-css';
import { NewStepDescription } from 'assets/css/common-styles';
import { getMapImage, getRegionImage } from 'components/wh/util';

const WHStep4 = ({ whRegionData, formikProp }) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = formikProp;

  const showMessage = () => {
    Message.error(
      `This zone is temporarily unavailable.Please contact our team to know
        when it will be available again.`,
      'Unavailable',
    );
  };
  const setIsChecked = (value) => {
    setFieldValue('region', value);
  };

  return (
    <Styles.WHStep2SC id="ST4">
      <Heading name={'wh/create.step4_string1'}>
        <Styles.Margin>
          <NewStepDescription />
          <P>{t('wh/create.step4_string2')}</P>
          <Styles.DataCenterGrid>
            {get(whRegionData, 'data', []).map((region) => (
              <div key={region.id}>
                {!region.deployable ? (
                  <Styles.Card0 onClick={showMessage}>
                    <img
                      style={{ borderRadius: '50px', width: '30px', height: '30px' }}
                      src={getRegionImage(region.country)}
                      alt="flag Image"
                    />
                    <img style={{ marginTop: '1em' }} src={getMapImage(region.country)} alt="flag Image" />
                    <Styles.Heading>{t(`wh/create.${region.i18n_key}`)}</Styles.Heading>
                    <div style={{ marginTop: '-5px' }}>
                      <div style={{ position: 'absolute', bottom: '3px', right: 0 }}>
                        <Checkbox data={region} setCheckedValue={showMessage} />
                      </div>
                    </div>
                  </Styles.Card0>
                ) : (
                  <Styles.Card
                    selected={region.id == values.region}
                    onClick={() => {
                      setIsChecked(region.id);
                    }}
                  >
                    <img
                      style={{ borderRadius: '50px', width: '30px', height: '30px' }}
                      src={getRegionImage(region.country)}
                      alt="flag Image"
                    />
                    <img style={{ marginTop: '1em' }} src={getMapImage(region.country)} alt="flag Image" />
                    <Styles.Heading>{t(`wh/create.${region.i18n_key}`)}</Styles.Heading>
                    <div style={{ marginTop: '-5px' }}>
                      <div style={{ position: 'absolute', bottom: '3px', right: 0 }}>
                        <Checkbox
                          data={region}
                          setCheckedValue={(value) => setIsChecked(value)}
                          checkbox={values.region}
                          onClick={() => {
                            setIsChecked(region.id);
                          }}
                        />
                      </div>
                    </div>
                  </Styles.Card>
                )}
              </div>
            ))}
          </Styles.DataCenterGrid>
        </Styles.Margin>
        <FormikErrorMessage formikProp={formikProp} value="region" />
      </Heading>
    </Styles.WHStep2SC>
  );
};
export default WHStep4;
